(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function splitIntoWords(el) {
    if (el.dataset.ehsSplit) return;
    el.dataset.ehsSplit = 'true';
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var textNodes = [];
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() !== '') textNodes.push(node);
    }
    textNodes.forEach(function (textNode) {
      var words = textNode.nodeValue.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      words.forEach(function (word) {
        if (word.trim() === '') {
          frag.appendChild(document.createTextNode(word));
        } else {
          var span = document.createElement('span');
          span.className = 'ehs-word';
          span.textContent = word;
          frag.appendChild(span);
        }
      });
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  function playReveal(slide) {
    if (!slide) return;
    var targets = slide.querySelectorAll('.text-block');
    targets.forEach(function (block, blockIndex) {
      splitIntoWords(block);
      var words = block.querySelectorAll('.ehs-word');
      words.forEach(function (word, i) {
        word.classList.remove('is-visible');
        word.style.transitionDelay = (blockIndex * 250 + i * 30) + 'ms';
      });
      // Force reflow so the removed class / reset delay is picked up before re-adding.
      void block.offsetHeight;
      requestAnimationFrame(function () {
        words.forEach(function (word) {
          word.classList.add('is-visible');
        });
      });
    });
  }

  function initSection(section) {
    var slideshow = section.querySelector('slideshow-component');
    if (!slideshow) return;

    var activeSlide = slideshow.querySelector('slideshow-slide:not([aria-hidden="true"])');
    playReveal(activeSlide);

    slideshow.addEventListener('slideshow:select', function (event) {
      playReveal(event.detail && event.detail.slide);
    });
  }

  function init() {
    // Reduced motion: leave text exactly as rendered by Liquid (no spans,
    // no opacity toggling) rather than mirroring the animated path.
    if (reduceMotion) return;

    document.querySelectorAll('.everart-hero-slideshow').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

